import { root, id } from './cues';

export const cues = {
  ...root,
  id,
};
